import specPicApi from '../../apis/spec.pic.api';
import Vue from 'vue';
let getSpecParametersPromises = {};
export default {
  state: {
    paramList: {}
  },
  mutations: {
    setSpecParameterData (state, { specId, parammeters }) {
      let key = `${specId}`;
      Vue.set(state.paramList, key, parammeters);
    }
  },
  getters: {
    currentParamList: state => (specId) => {
      let key = `${specId}`;
      return state.paramList[key];
    }
  },
  actions: {
    getSpecParameters ({ state, commit }, { specId, newsPrice }) {
      state.currentSpecId = specId;
      let key = `${specId}`;
      if (state.paramList[key]) {
        commit('setSpecParameterData', { specId, parammeters: state.paramList[key] });
        return Promise.resolve(state.paramList[key]);
      }
      if (getSpecParametersPromises[key]) {
        return getSpecParametersPromises[key];
      }
      getSpecParametersPromises[key] = specPicApi.getSpecParameters(specId).then(function (result) {
        const data = result.ParamTypeItems;
        if (data.length > 0) {
          if (data[0].ParamItems.length > 0) {
            data[0].ParamItems[0].Name = '优惠价(元)';
            data[0].ParamItems[0].Value = newsPrice;
          }
        }
        commit('setSpecParameterData', { specId, parammeters: data });
        return Promise.resolve(data);
      });
      return getSpecParametersPromises[key];
    }
  },
  namespaced: true
};
